<template>
  <v-container>
    <v-layout>
    <v-flex>       
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>    
    </v-layout>
       <h3 class="primary--text">Lista de clientes</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.companies"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">         
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>          
          <td class="text-xs-left">{{ props.item.status?"Activo":"Inactivo" }}</td>
          <td>
            <v-tooltip top >
               <v-btn 
               fab dark 
               small @click="irActividades(props.item)" 
               slot="activator"
               color="primary">
                <v-icon dark>local_activity</v-icon>
              </v-btn>
              <span>Ir a actividades</span>
              </v-tooltip>
              <v-tooltip top >
                <v-btn fab dark small @click="irConfiguracion(props.item)" 
                  slot="activator" 
                  color="primary">
                  <v-icon dark>settings_applications</v-icon>
                </v-btn>
              <span>Ir a configuración</span>
              </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="irPeriodos(props.item)"
                     slot="activator"
                     color="primary">
                <v-icon dark>calendar_today</v-icon>
              </v-btn>
              <span>Ir a periodos</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
      <v-dialog
            fullscreen
            v-model="dialog"
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable>
        <v-card tile>
            <v-card-text overflow-y height="100%">
                <v-toolbar card dark color="nav_background_color">
                    <v-btn icon dark @click.native="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{nombreEmpresa}} Configuración de usuarios</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-layout v-for="item in this.medicos" :key="item">
                        <v-flex  xs12 sm4 offset-sm1>
                          <v-combobox
                              :items="$store.state.users"
                              :label="item.label"
                              v-model="item.data"
                              item-text="completeName"
                              item-value="login"
                              return-object
                              persistent-hint
                              :rules="[v => !!v || 'Campo requerido']"
                              required
                          >
                          </v-combobox>
                        </v-flex>
                      </v-layout>
                      <v-btn color="primary" @click="agregarMedico" dark>Agregar Médico</v-btn>
                      <v-btn color="primary" @click="eliminarMedico" dark>Eliminar Médico</v-btn>


                      <br>
                      <br>
                      <br>

                      <v-layout wrap align-center>
                        <v-flex xs12 sm4 offset-sm1>
                          <v-combobox
                              :items="$store.state.users"
                              v-model="$store.state.companyActivityUser.supervisor"
                              label="Supervisor 1"
                              item-text="completeName"
                              item-value="login"
                              :rules="[v => !!v || 'Campo requerido']"
                              return-object
                              persistent-hint
                              required
                          >
                          </v-combobox>
                          <v-combobox
                              :items="$store.state.users"
                              v-model="$store.state.companyActivityUser.supervisor2"
                              label="Supervisor 2"
                              item-text="completeName"
                              item-value="login"                              
                              return-object
                              persistent-hint                              
                          >
                          </v-combobox>
                        </v-flex>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-combobox
                                :items="$store.state.users"
                                v-model="$store.state.companyActivityUser.medicoCliente"
                                label="Médico cliente 1"
                                item-text="completeName"
                                item-value="login"
                                :rules="[v => !!v || 'Campo requerido']"
                                return-object
                                persistent-hint
                                required
                            >
                            </v-combobox>
                            <v-combobox
                                :items="$store.state.users"
                                v-model="$store.state.companyActivityUser.medicoCliente2"
                                label="Médico cliente 2"
                                item-text="completeName"
                                item-value="login"                                    
                                return-object
                                persistent-hint                                    
                            >
                            </v-combobox>
                        </v-flex>
                      </v-layout>
                      <br>
                      <br>
                      <v-layout>
                        <v-flex class="text-xs-center">
                          <div>
                            <v-btn @click="guardar"
                                   dark color="primary">Guardar
                            </v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-form>
                </v-card-text>
            </v-card-text>
        </v-card>

    </v-dialog>
  </v-container>
</template>
<script>

  import Activity from '@/components/activity/Activity';
  import ActivityConfigurationCompany from "../activity/ActivityConfigurationCompany";

  export default {    
    data () {
      return {
        dialog: false,
        search: '',
        valid: false,
        codeRules: [
          v => !!v || 'El código es requerido',
          v => (v && v.length <= 13) || 'El código debe tener 10 o 13 caracteres'
        ],
        requiredField:[v => !!v || 'Es requerido'],
        headers: [
          { text: 'Cédula/RUC', value: 'code' },
          { text: 'Nombre', value: 'name' },          
          { text: 'Estado', value: 'estado' },
          { text: 'Acciones', value: 'editar' },

        ],
        editedIndex: -1,        
        itemsDecision: ['Si', 'No'],
        agencies:[],
        disabledTab: true,
        active: 0,
        nombreEmpresa: '',
        medicoCount:1,
        medicos:[{label:"Médico Inscora 1"}],
        companyIdSelected: ''
      };
    },
    methods:{
      agregarMedico(){
        this.medicoCount++
        this.medicos.push({label:"Médico Inscora "+this.medicoCount})
      },
      eliminarMedico(){
        this.medicoCount--
        this.medicos.splice(this.medicos.length-1,1)
      },
      irActividades(item) {
        this.$store.state.companyActivity = item
        const activities = 
            {
                path: "/activityConfigurationCompany",
                component: ActivityConfigurationCompany
            };
        this.$router.push(activities);
      },
      irPeriodos(item) {
        this.$store.state.companyActivity = item
        this.$router.push({path: "/activityCompanyPeriod"});
      },
      irConfiguracion(item) {
          this.$store.state.companyActivityUser.medicos = [];
          delete this.$store.state.companyActivityUser.supervisor;
          delete this.$store.state.companyActivityUser.supervisor2;
          delete this.$store.state.companyActivityUser.medicoCliente;
          delete this.$store.state.companyActivityUser.medicoCliente2;
          this.$refs.form.resetValidation();
          this.companyIdSelected = item.id;                    
          this.nombreEmpresa = item.name;                 
          this.$store.dispatch('getActivityCompanyUsers', this.companyIdSelected).then(response => {
            let supervisores = [];
            let clientes = [];
            for (let i=0; i<response.data.length; i++) {                         
              response.data[i].user.completeName= response.data[i].user.firstName+" "+response.data[i].user.lastName+" - "+response.data[i].user.identification;              
              if (response.data[i].tipo === 'u') {
                this.$store.state.companyActivityUser.medicos.push(response.data[i].user);
              } else if (response.data[i].tipo === 's') {                
                supervisores.push(response.data[i].user);
              } else if (response.data[i].tipo === 'c') {                
                clientes.push(response.data[i].user);
              }
            }                  
            if (supervisores.length == 1) {
              this.$store.state.companyActivityUser.supervisor = supervisores[0];
            } 
            if (supervisores.length == 2) {
              this.$store.state.companyActivityUser.supervisor = supervisores[0];
              this.$store.state.companyActivityUser.supervisor2 = supervisores[1];
            }
            if (clientes.length == 1) {
              this.$store.state.companyActivityUser.medicoCliente = clientes[0];
            } 
            if (clientes.length == 2) {
              this.$store.state.companyActivityUser.medicoCliente = clientes[0];
              this.$store.state.companyActivityUser.medicoCliente2 = clientes[1];
            }     
            if(this.$store.state.companyActivityUser.medicos
                && this.$store.state.companyActivityUser.medicos.length > 0) {       
              this.medicos = [];                   
              for (let i=0; i<this.$store.state.companyActivityUser.medicos.length; i++) {                                                
                this.medicos.push({label:"Médico Inscora "+this.medicoCount, 
                                   data: this.$store.state.companyActivityUser.medicos[i]});
                this.medicoCount++;
              }
            } else {
              console.log('entra else')
              this.medicos = [{label:"Médico Inscora 1"}];
            }            
            this.dialog = true;
          }, error => {
            this.$store.state.dialogError = true;
          })          
      },
      guardar() {
        if (this.$refs.form.validate()) { 
            this.$store.state.companyActivityUser.medicos=this.medicos         
            let activityCompanyUsers = [];
            let company = {id:this.companyIdSelected};
            let user = {};
            let acu = {};
            let tipo = '';
            for (let i=0; i<this.medicos.length; i++) {
              if (this.medicos[i].data &&
                this.medicos[i].data.login != "-1") {        
                user = {id:this.medicos[i].data.id};
                tipo = 'u';
                acu = {company, user, tipo};
                activityCompanyUsers.push(acu);
              }
            }
            if (this.$store.state.companyActivityUser.supervisor &&
              this.$store.state.companyActivityUser.supervisor.login != "-1") {
              user = {id:this.$store.state.companyActivityUser.supervisor.id};
              tipo = 's';
              acu = {company, user, tipo};
              activityCompanyUsers.push(acu);
            }
            console.log(this.$store.state.companyActivityUser.supervisor2)
            if (this.$store.state.companyActivityUser.supervisor2 &&
              this.$store.state.companyActivityUser.supervisor2.login != "-1") {
              user = {id:this.$store.state.companyActivityUser.supervisor2.id};
              tipo = 's';
              acu = {company, user, tipo};
              activityCompanyUsers.push(acu);
            }

            if (this.$store.state.companyActivityUser.medicoCliente &&
              this.$store.state.companyActivityUser.medicoCliente.login != "-1") {
              user = {id:this.$store.state.companyActivityUser.medicoCliente.id};
              tipo = 'c';
              acu = {company, user, tipo};
              activityCompanyUsers.push(acu);
            }
            
            if (this.$store.state.companyActivityUser.medicoCliente2 &&
              this.$store.state.companyActivityUser.medicoCliente2.login != "-1") {
              user = {id:this.$store.state.companyActivityUser.medicoCliente2.id};
              tipo = 'c';
              acu = {company, user, tipo};
              activityCompanyUsers.push(acu);
            }
                 
            this.$store.dispatch('deleteActivityCompanyUsersByCompanyId', this.companyIdSelected).then(
              response => {
                for (let i=0; i<activityCompanyUsers.length; i++) {
                  this.$store.dispatch('addActivityCompanyUsers', activityCompanyUsers[i]).then(
                    response => {              
                    },
                    error => {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                    }
                  );
                }
              },
              error => {
                this.$store.state.progress = false;
                this.$store.state.dialogError = true;
              }
            );                      
          this.dialog = false
        }        
      }
    },
    computed : {
    },
    beforeCreate(){      
      this.$store.dispatch('getUsers').then(response => {
        this.$store.state.users.unshift({login: "-1", completeName: "Seleccione"});        
      })
      this.$store.dispatch('getCompaniesStatusActive').then(response => {
      }, error => {
        this.$store.state.dialogError = true;
      }),
      this.$store.dispatch('getTypes').then(
        response => {                  
        },
        error => {
          this.$store.state.dialogError = true;
        }
      );
    },
    components: {       
      Activity 
    }
    }
</script>

<style scoped>
  li{
    list-style:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/activityCompany/ActivityCompany.vue